<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row justify="center">
          <v-col align="center" cols="6" md="2">
            <router-link :to="`/reported-posts`">
              <v-icon color="#066a8c">mdi-post-outline</v-icon>
              <div class="mnuBtn">Reported Posts</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2">
            <router-link :to="`/reported-users`">
              <v-icon color="#066a8c">mdi-account-group</v-icon>
              <div class="mnuBtn">Reported Users</div>
            </router-link>
          </v-col>
          <v-col align="center" cols="6" md="2" class="btn_bg">
            <router-link :to="`/reported-medias`">
              <v-icon color="#066a8c">mdi-folder-multiple-image</v-icon>
              <div class="mnuBtn">Reported Medias</div>
            </router-link>
          </v-col>
        </v-row>

        <v-row>
          <div class="user-wrapper">
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
            >
              <div class="md-card md-theme-default fullwidth">
                <div class="md-card-content">
                  <v-row>
                    <v-col md="3"
                      ><span class="header_title"> Reported Medias</span></v-col
                    >

                    <v-spacer></v-spacer>
                    <v-col md="2" class="mr-3">
                      <div style="width: 120px; float: right">
                        <v-select
                          outlined
                          v-model="perPage"
                          label="Per Page"
                          :items="[10, 15, 25, 50]"
                          @change="searchData"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>

                  <div
                    class="md-content md-table md-theme-default table_borders"
                    table-header-color="orange"
                    value
                  >
                    <div
                      class="md-content md-table-content md-scrollbar md-theme-default"
                    >
                      <table>
                        <thead class="md-card-header">
                          <tr>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Media</div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Post Title
                                </div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Title"
                                    v-model="searchParams.title"
                                    item-value="title"
                                    item-text="title"
                                    :items="titles"
                                    :loading="isLoading"
                                    :search-input.sync="title"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">User</div>
                              </div>
                              <div class="search_column">
                                <v-autocomplete
                                  solo
                                  filled
                                  label="User"
                                  v-model="searchParams.user_id"
                                  item-value="id"
                                  item-text="name"
                                  :loading="isLoading"
                                  :items="['All', ...user_ids]"
                                  @change="getFilterData"
                                ></v-autocomplete>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Reported By
                                </div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Reason</div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Action</div>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            class="md-table-row"
                            v-for="data in searchData"
                            :key="data.id"
                          >
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <view-image
                                  :image="data.media"
                                  :defaultImage="'user'"
                                  :height="50"
                                  :width="50"
                                ></view-image>
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  small
                                  color="#00b0af"
                                  class="d-inline-block text-truncate"
                                  style="
                          max-width: 130px;
                          min-width: 130px;
                          text-transform: none;
                        "
                                  dark
                                  @click="showPostModel(data.id)"
                                >
                                  <span class="text-truncate">{{
                                    data.title
                                  }}</span></v-btn
                                >
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  @click="
                                    $router.push({
                                      name: 'ViewUser',
                                      params: { userId: data.user_id },
                                    })
                                  "
                                  small
                                  color="normal"
                                  >{{
                                    data.user != null ? data.user : "NA"
                                  }}</v-btn
                                >
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  @click="
                                    $router.push({
                                      name: 'ViewUser',
                                      params: { userId: data.reported_user_id },
                                    })
                                  "
                                  small
                                  color="normal"
                                  >{{
                                    data.reported_user != null
                                      ? data.reported_user
                                      : "NA"
                                  }}</v-btn
                                >
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.reason || "--" }}
                              </div>
                            </td>
                            <td class="md-table-cell" style="min-width: 120px">
                              <v-btn
                                small
                                color="error"
                                class="d-inline-block text-truncate"
                                dark
                                @click="confirmDelete(data.id)"
                              >
                                <span class="text-truncate">Delete</span></v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <confirm-model
      v-bind="confirmModel"
      @confirm="confirmActions"
      @close="confirmModel.id = null"
    ></confirm-model>
    <post-model v-bind="postModel" @close="postModel.postID = null" />
  </v-container>
</template>
<script>
import PostModel from "../Post/PostModel";
import ConfirmModel from "@/components/Confirmation/ConfirmModel";
import moment from "moment";
export default {
  components: {
    PostModel,
    ConfirmModel,
  },
  data() {
    return {
      user_ids: [],
      user_id: null,
      userForm: {},
      currentPage: 0,
      pageSize: 10,
      titles: [],
      title: null,
      isLoading: false,
      searchData: [],
      menu1: false,
      menu2: false,
      flag: false,
      searchFlag: false,
      date1: moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      searchParams: {
        timestamp: null,
        start_date: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      page: 1,
      perPage: null,
      totalPages: 1,
      priceMenu: false,
      timeDuration: [
        { name: "All", title: "All" },
        { name: "week", title: "This Week" },
        { name: "year", title: "This Year" },
        { name: "month", title: "This Month" },
        { name: "custom", title: "Custom Duration" },
      ],
      postModel: { postID: null, type: "details" },
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
    };
  },
  mounted() {
    if (this.$store.getters.getCountries.status == false) {
      this.$store.dispatch("loadCountries");
    }
    this.getPostUsers();
    this.search();
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.data;
    },
  },
  watch: {
    page() {
      this.search();
    },
    title(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("title", val);
    },
    user_id(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("user", val);
    },
  },
  methods: {
    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
        .get("posts/admin/filter-posts?field=" + type + "&search=" + val)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            if (type == "title") {
              this.titles = response.data.data;
              this.titles.unshift(val);
              this.titles.unshift("All");
            } else if (type == "user") {
              this.user_ids = response.data.data;
              this.user_ids.unshift(val);
              this.user_ids.unshift("All");
            }
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getFilterData() {
      this.page = 1;
      this.search();
    },
    getPostUsers() {
      this.isLoading = true;
      this.$http
        .get("posts/admin/post-users")
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            this.user_ids = response.data.data;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    showPostModel(postId) {
      this.postModel.postID = parseInt(postId);
      this.postModel.type = "details";
    },
    confirmDelete(id) {
      let msg =
        "This will delete the post. By clicking Yes you can confirm the operation.";
      this.confirmModel = {
        id: id,
        title: `Do you want to delete the post?`,
        description: msg,
      };
    },
    search() {
      let url = "";
      if (
        typeof this.searchParams.title != "undefined" &&
        this.searchParams.title !== "All"
      ) {
        url += "&title=" + this.searchParams.title;
      }
      if (
        typeof this.searchParams.user_id != "undefined" &&
        this.searchParams.user_id !== "All"
      ) {
        url += "&user_id=" + this.searchParams.user_id;
      }

      this.showLoader("Loading Posts");
      this.$http
        .get(
          "posts/admin/reported-medias?page=" +
            this.page +
            "&per_page=" +
            (this.perPage != null ? this.perPage : 10) +
            url
        )
        .then((response) => {
          this.hideLoader();
          if (response.status == 200 && response.data.status) {
            this.searchData = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    changePostStatus(id) {
      this.$http
        .put(`posts/admin/toggle-status/${id}`)
        .then((response) => {
          if (response.status == 200) {
            this.showSuccess(`Post Deleted Successfully`);
            this.search();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },

    confirmActions(data) {
      this.changePostStatus(data.id);
      this.$forceUpdate();
      this.confirmModel.id = null;
    },
  },
};
</script>
<style scoped>

.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
.salesBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #066a8c;
}
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
